import ReactOnRails from 'react-on-rails';
import { reportWebVitals } from 'src/helpers/reportWebVitals';
import { reportGoogleTranslate } from 'src/utils/reportGoogleTranslate/reportGoogleTranslate';
import '../styles/pages/search_page.scss';

import SearchPage from '../routes/SearchPage';

ReactOnRails.register({ SearchPage });

reportWebVitals();

reportGoogleTranslate();
